<!-- @format -->

<template>
	<div>
		<CoreDropdown
			v-model="type"
			:options="typeOptions"
			:disabled="true"
			class="mb-5"
		/>

		<p
			v-if="year"
			class="upload-client-file-modal__year mb-5"
		>
			{{ $t('§eq_operator.company_file_year_and_as_of', { year, date: asOfDisplay }) }}
		</p>

		<CoreFileUpload
			class="mb-5"
			name="file"
			accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx"
			ref="fileUpload"
			:acceptJson="true"
			:metadata="metadata"
			:uploadUrl="uploadUrl"
			@file-added="handleFileAdded"
			@uploaded="handleSuccess"
			@upload-error="handleUploadError"
		/>

		<div class="flex justify-start gap-2">
			<CoreButton
				:disabled="!isFileSelected"
				label="§ui_button.upload"
				icon="pi-upload"
				:loading="saving"
				@click="handleUpload"
			/>

			<CoreButton
				label="§ui_button.cancel"
				variant="tertiary"
				:disabled="saving"
				@click="handleClose"
				icon="pi-times"
			/>
		</div>
	</div>
</template>

<script>
import { parseISO } from 'date-fns'
import { useModalStore } from '@/stores/modal'
import { useClientFilesStore } from '@/stores/clientFiles'
import CoreDropdown from '@/components/core/CoreDropdown.vue'
import CoreButton from '@/components/core/CoreButton.vue'
import CoreFileUpload from '@/components/core/CoreFileUpload.vue'

export default {
	name: 'UploadClientFileModal',

	components: {
		CoreDropdown,
		CoreButton,
		CoreFileUpload,
	},

	data() {
		const modalStore = useModalStore()

		return {
			clientId: modalStore.data?.clientId ?? null,
			type: modalStore.data?.type ?? '',
			year: modalStore.data?.year ?? null,
			asOf: modalStore.data?.asOf ?? null,
			saving: false,
			isFileSelected: false,
		}
	},

	computed: {
		typeOptions() {
			return [{ label: this.$t(`§eq_operator.company_file_type_${this.type}`), value: this.type }]
		},

		metadata() {
			return this.year ? { type: this.type, fiscal_year: this.year } : { type: this.type }
		},

		asOfDisplay() {
			return this.asOf ? this.displayAsDate(parseISO(this.asOf)) : ''
		},

		uploadUrl() {
			return this.route('client.files.upload', { client: this.clientId })
		},
	},

	created() {
		this.modalStore = useModalStore()
		this.clientFilesStore = useClientFilesStore()
	},

	methods: {
		handleFileAdded() {
			this.isFileSelected = true
		},

		handleClose() {
			this.modalStore.setClose()
		},

		handleUpload() {
			this.isFileSelected = false

			if (!this.saving && this.$refs.fileUpload) {
				this.saving = true
				this.$refs.fileUpload.upload()
			}
		},

		handleSuccess(xhr) {
			let response = null
			try {
				response = JSON.parse(xhr?.response)
			} catch (error) {
				response = null
			}

			if (response?.file?.id) {
				this.clientFilesStore.addFile(response.file, this.clientId)
				this.clientFilesStore.applyRegistryState(this.clientId, response)

				const onUploaded = this.modalStore.data?.onUploaded
				if (typeof onUploaded === 'function') {
					onUploaded(response.file, response)
				}
			}

			this.saving = false
			this.isFileSelected = false
			this.handleClose()
		},

		handleUploadError() {
			this.saving = false
			this.isFileSelected = false
		},
	},
}
</script>
